import { useQuery } from 'react-query';

import { useCommonCrossingInfoBannerState } from '@/features/easy/shared/hooks';
import { TRAILER_LOAD_MODE } from '@/features/shared/constants';
import { axios } from '@/lib/axios';

type GetCrossingInfoBannerDTO = {
  folderTypologyId: string;
  folderId: string;
};

type GetCommonCrossingInfoBannerResponse = {
  trailerLoadMode: TRAILER_LOAD_MODE;
  hasBeenSaved: boolean;
  folderNumber: string;
  direction: string;
};

const getCrossingInfoBannerAsync = ({ folderTypologyId, folderId }: GetCrossingInfoBannerDTO) =>
  axios.get<GetCommonCrossingInfoBannerResponse>(
    `/folder-typologies/${folderTypologyId}/folders/${folderId}/crossing-info-banner`,
  );

export function useGetCommonCrossingInfoBannerAsync(
  { folderTypologyId, folderId }: GetCrossingInfoBannerDTO,
  { isEnabled }: { isEnabled: boolean } = { isEnabled: true },
) {
  return useQuery({
    queryKey: ['crossing-info-banner', folderId, folderTypologyId],
    queryFn: async () => {
      const { data } = await getCrossingInfoBannerAsync({ folderId, folderTypologyId });
      return data;
    },
    retry: 5,
    cacheTime: 0,
    enabled: isEnabled,
    onSuccess: ({ direction, trailerLoadMode }) => {
      useCommonCrossingInfoBannerState.setState({ direction, trailerLoadMode });
    },
  });
}
